import { BrregOrgDto, useLookupBrregOrgQuery } from "../../../autogen/bff-api";
import { useBaseData } from "../../../common/useBaseData";

interface Args {
  countryId: string | undefined;
  organizationNumber: string | undefined;
}

interface Result {
  brregInfo: BrregOrgDto | undefined;
  isFetching: boolean;
}

export function useBrregAutoFill({ countryId, organizationNumber }: Args): Result {
  const baseData = useBaseData();
  const norwayCountryId = baseData.countries.find((c) => c.alpha3Code === "NOR")?.id;

  const trimmedOrgnr = organizationNumber?.replace(/\s+/g, "") ?? "";
  const isNorwegianNineDigitOrgnr = countryId === norwayCountryId && /^\d{9}$/.test(trimmedOrgnr);

  const { data: brregInfo, isFetching } = useLookupBrregOrgQuery(
    { organizationNumber: trimmedOrgnr },
    { skip: !isNorwegianNineDigitOrgnr }
  );

  return { brregInfo, isFetching };
}
